import { css, unsafeCSS } from 'lit';

import token from '../../../utils/get-token';

import { defaultSidebarProps } from './sidebar.constants';

export function getFlexDirectionValue(reversed?: boolean) {
	return reversed ? 'row-reverse' : 'row';
}

export function sidebarStyles() {
	return css`
		:host {
			--m-sidebar-gap: ${token(defaultSidebarProps.gap)};
			--m-sidebar-flex-direction: ${unsafeCSS(
				getFlexDirectionValue(defaultSidebarProps.reversed),
			)};
			--m-sidebar-side-width: ${unsafeCSS(defaultSidebarProps.sideWidth)};
			--m-sidebar-min-content-width: ${unsafeCSS(
				defaultSidebarProps.minContentWidth,
			)};

			display: flex;
			flex-wrap: wrap;
			flex-direction: var(--m-sidebar-flex-direction);

			gap: var(--m-sidebar-gap);
		}

		slot[name='sidebar']::slotted(*) {
			flex-basis: var(--m-sidebar-side-width);
			flex-grow: 1;
		}

		slot[name='content']::slotted(*) {
			flex-basis: 0;
			flex-grow: 999;
			min-width: var(--m-sidebar-min-content-width);
		}
	`;
}
